// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__blsGC","hasIcon":"button_hasIcon__2aNsy","hasText":"button_hasText__2ZS2R","loading":"button_loading__3PYKO","loader":"button_loader__VVIda"};